import { useParams } from "react-router-dom";
import StockHomeContainer from "src/container/stockhome";
import { Helmet } from "react-helmet-async";

const StockHome = () => {
  const { id } = useParams();

  return (
    <>
      <Helmet>
        <title>텔레모아::핵심 텔레그램 채널의 중요 정보를 모아!</title>
        <meta name="description" content="쉽고 빠르게 확인하는 투자의 온도, 이 종목에 대한 텔레모아 분석결과는?" />
      </Helmet>
      <div className="container mt-4">
          <div className="row">
              <StockHomeContainer isu_srt_cd={id} rowPerPage={20} />
          </div>
      </div>
    </>
  );
};

export default StockHome;
